module.exports = __webpack_public_path__ + "img/cafe_thumbnail-400x300.f950ed5a.jpg";